import request from "@/utils/request";

export function queryShopCollectList(params) {
  return request({
    url: "/api/system/shopCollect/queryShopCollectList",
    method: "post",
    data: params
  });
}
export function getShopCollect(params) {
  return request({
    url: "/api/system/shopCollect/getShopCollect",
    method: "post",
    data: params
  });
}
export function saveShopCollect(params) {
  return request({
    url: "/api/system/shopCollect/saveShopCollect",
    method: "post",
    data: params
  });
}

export function queryShopCollectPage(params) {
  return request({
    url: "/api/system/shopCollect/queryShopCollectPage",
    method: "post",
    data: params
  });
}
export function updateShopCollect(params) {
  return request({
    url: "/api/system/shopCollect/updateShopCollect",
    method: "post",
    data: params
  });
}
export function queryCollectAndProduct(params) {
  return request({
    url: "/api/system/shopCollect/queryCollectAndProduct",
    method: "post",
    data: params
  });
}




// WEBPACK FOOTER //
// ./src/api/collect/index.js